import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryEntries() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14">
      <div className="flex items-end justify-between mb-6 md:mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">分类快捷入口</h2>
          <p className="mt-2 text-sm text-foreground-600">按内容类型快速进入，发现属于你的下一部心头好</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${encodeURIComponent(cat.id)}`}
            className="group relative h-44 md:h-52 rounded-lg overflow-hidden border border-background-200 hover:border-primary-500/60 transition-colors cursor-pointer"
          >
            <img
              src={cat.poster}
              alt={`${cat.name}分类`}
              title={`${cat.name} - 嫩草视频分类推荐`}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/50 to-transparent"></div>
            <div className="relative h-full flex flex-col justify-end p-5">
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 mb-3">
                <i className={`${cat.icon} text-2xl`}></i>
              </span>
              <h3 className="text-xl font-heading text-foreground-950">{cat.name}</h3>
              <p className="mt-1 text-xs md:text-sm text-foreground-600 line-clamp-2">{cat.desc}</p>
            </div>
            <span className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center rounded-full bg-background-100/70 text-foreground-950 opacity-0 group-hover:opacity-100 transition-opacity">
              <i className="ri-arrow-right-up-line text-lg"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}